var map = {
	"./partner1.png": 2953,
	"./partner10.png": 3262,
	"./partner11.png": 2307,
	"./partner12.png": 8096,
	"./partner13.png": 4076,
	"./partner14.png": 1437,
	"./partner15.png": 5161,
	"./partner16.png": 2933,
	"./partner17.png": 8479,
	"./partner18.png": 2591,
	"./partner2.png": 1291,
	"./partner3.png": 1695,
	"./partner4.png": 1478,
	"./partner5.png": 9651,
	"./partner6.png": 4061,
	"./partner7.png": 2540,
	"./partner8.png": 7152,
	"./partner9.png": 6938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1538;